<script>
import '/local/templates/redesign/src/assets/scss/pages/sme.scss';
import mainServices from '../../components-manual/molecules/mainServices.vue';
import Advantages from '../../components-manual/molecules/Advantages.vue';
import TableSmeWrap from '../../components-manual/sme/TableSmeWrap.vue';
import SmeLk from '../../components-manual/sme/SmeLk.vue';
import SmeFormMessage from '../../components-manual/sme/SmeFormMessage.vue';
import { DButton } from '@ahml/domrfbank-ui/elements/DButton';
import { DTabs } from '@ahml/domrfbank-ui/elements/DTabs';

export default {
    components: {
        mainServices,
        Advantages,
        TableSmeWrap,
        SmeLk,
        SmeFormMessage,
        DButton,
        DTabs,
    },
};
</script>
